import * as React from 'react';
import { useContext, useState } from 'react';
import { AuthContext } from '../_auth/AuthContext';
import { Route, Redirect } from 'react-router-dom';

const SecuredRoute: React.FC<any> = ({ component: Component, ...rest}) => {

    const { user, setUser } = useContext(AuthContext);
    const [ dsp, setDsp ] = useState<boolean>(true);


    const { checkPermission } = rest;

    if (checkPermission) {

        if (!user) {
            setDsp(false);
            
        } else {
            if (checkPermission) {
                checkPermission(user, setUser).then((r: boolean) => {
                    setDsp(r);
                });
            }
             
        }
    };

    return (
        <Route
          {...rest}
          render={(props) => user.authorized === true 
            ? dsp === true ? <Component {...props} /> : <Redirect to={{pathname: '/', state: { from: props.location}}} />
            : <Redirect to={{pathname: '/login', state: {from: props.location}}} />}
        />
      )

};

export default SecuredRoute;

